// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2VQTX","selects":"Documents_selects__1RDW6"};